import { render, staticRenderFns } from "./Play_Check.vue?vue&type=template&id=32fd8fe2&scoped=true"
import script from "./Play_Check.vue?vue&type=script&lang=js"
export * from "./Play_Check.vue?vue&type=script&lang=js"
import style0 from "./Play_Check.vue?vue&type=style&index=0&id=32fd8fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fd8fe2",
  null
  
)

export default component.exports